module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 85
// module chunks = 129